// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Caml from "../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Spread$Showside from "../utils/Spread.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as ProductPrice$Showside from "./ProductPrice.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as StoreProvider$Showside from "../context/StoreProvider.bs.js";
import * as IconTriangleUp$Showside from "../icons/IconTriangleUp.bs.js";
import * as ProductReviews$Showside from "./ProductReviews.bs.js";
import * as DynamicTruncate$Showside from "./DynamicTruncate.bs.js";
import * as ProductListItem$Showside from "./ProductListItem.bs.js";
import * as QuickViewButton$Showside from "./QuickViewButton.bs.js";
import * as ResizeObserver2$Showside from "../utils/ResizeObserver2.bs.js";
import * as IconTriangleDown$Showside from "../icons/IconTriangleDown.bs.js";
function ProductPin(Props) {
  var sizeOpt = Props.size;
  var dynamicTooltipWidthOpt = Props.dynamicTooltipWidth;
  var shape = Props.shape;
  var pin = Props.pin;
  var onClick = Props.onClick;
  var dotColor = Props.dotColor;
  var scaleOpt = Props.scale;
  var bounds = Props.bounds;
  var dotStyle = Props.dotStyle;
  var highlighted = Props.highlighted;
  var enableTipOpt = Props.enableTip;
  var imageFitToContainerOpt = Props.imageFitToContainer;
  var hideOutOfStockOpt = Props.hideOutOfStock;
  var displayVariantByOpt = Props.displayVariantBy;
  var trackEvent = Props.trackEvent;
  var mediaWidth = Props.mediaWidth;
  var mediaHeight = Props.mediaHeight;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var dynamicTooltipWidth = dynamicTooltipWidthOpt !== undefined ? dynamicTooltipWidthOpt : false;
  var scale = scaleOpt !== undefined ? scaleOpt : 1.0;
  var enableTip = enableTipOpt !== undefined ? enableTipOpt : false;
  var imageFitToContainer = imageFitToContainerOpt !== undefined ? imageFitToContainerOpt : false;
  var hideOutOfStock = hideOutOfStockOpt !== undefined ? hideOutOfStockOpt : true;
  var displayVariantBy = displayVariantByOpt !== undefined ? displayVariantByOpt : /* FirstVariant */0;
  var store = StoreProvider$Showside.use(undefined);
  var canUseBounds = size ? true : false;
  var tipRef = React.useRef(null);
  var tipBounds = ResizeObserver2$Showside.useResizeObserver(tipRef);
  var tipWidth = size ? dynamicTooltipWidth ? Math.min(Math.max(bounds.width - 20 | 0, 114), 320) : 320 : 114;
  var tipHeight = tipBounds !== undefined ? Caml.int_min(118, 65 > tipBounds.height ? 65 : tipBounds.height) : size ? 118 : 65;
  var sx = bounds.width / mediaWidth * scale;
  var sy = bounds.height / mediaHeight * scale;
  var enableTip$1 = mediaWidth * sx < 320 ? false : enableTip;
  var tipLeft = pin.x * sx - tipWidth / 2.0 | 0;
  var tipRight = pin.x * sx + tipWidth / 2.0 | 0;
  var tipBottom = pin.y * sy + tipHeight | 0;
  var flipped = (tipBottom + (10 / sy | 0) | 0) > bounds.height;
  var pushRight = tipLeft < 0.0 ? (-tipLeft | 0) + 10 | 0 : 0;
  var pushLeft = tipRight > bounds.width ? tipRight - bounds.width + 10 | 0 : 0;
  var dx = (pushRight - pushLeft | 0) - (tipWidth / 2 | 0) | 0;
  var maxLimit = (-tipWidth | 0) - 10 | 0;
  var minLimit = tipWidth + 10 | 0;
  var dx$1 = Caml.int_max(maxLimit, minLimit < dx ? minLimit : dx);
  var dy = flipped ? (-tipHeight | 0) - 24 | 0 : 0;
  var x = pin.x;
  var y = pin.y;
  var xPercent = (x / mediaWidth * 100.0).toString() + "%";
  var yPercent = (y / mediaHeight * 100.0).toString() + "%";
  var containerStyle = {
    left: xPercent,
    padding: "22px",
    top: yPercent,
    transform: "translate(-22px, -22px) scale(" + scale.toString() + ")"
  };
  var dotStyle$1;
  if (dotStyle !== undefined) {
    var tmp = {};
    if (dotColor !== undefined) {
      tmp.backgroundColor = dotColor;
    }
    dotStyle$1 = Object.assign({}, tmp, Caml_option.valFromOption(dotStyle));
  } else {
    var tmp$1 = {};
    if (dotColor !== undefined) {
      tmp$1.backgroundColor = dotColor;
    }
    dotStyle$1 = tmp$1;
  }
  var popupStyle = {
    height: CSS$Showside.intToPx(tipHeight),
    left: CSS$Showside.intToPx(dx$1),
    top: CSS$Showside.intToPx(dy),
    width: CSS$Showside.intToPx(tipWidth)
  };
  var variant = Product$Showside.getInitialDisplayVariant(hideOutOfStock, pin.variantId, displayVariantBy, pin.product);
  var imgSrc = Belt_Option.getWithDefault(Product$Showside.Media.getImageUrlWithPosterFallback(variant.media), "");
  var onClick$1 = function (e) {
    e.stopPropagation();
    e.preventDefault();
    Belt_Option.forEach(onClick, function (callback) {
      Curry._2(callback, pin.product, variant);
    });
    Curry.app(trackEvent, ["Clicked Product Pin", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  };
  var renderImage = function (param) {
    if (size) {
      return React.createElement("div", {
        className: CSS$Showside.prefix("relative w-24 rounded overflow-hidden flex-shrink-0 flex aspect-ratio-4/3")
      }, React.createElement(SmartImg$Showside.make, {
        src: imgSrc,
        fit: /* Contain */2,
        alt: pin.product.name,
        priority: 0
      }));
    } else {
      return React.createElement("div", {
        className: CSS$Showside.prefix("relative w-16 h-16 rounded overflow-hidden flex-shrink-0 flex")
      }, React.createElement(SmartImg$Showside.Sized.make, {
        src: imgSrc,
        containerWidth: 48,
        containerHeight: 48,
        fit: imageFitToContainer ? /* Contain */2 : /* Cover */1,
        priority: 0,
        alt: pin.product.name
      }));
    }
  };
  var renderProductTitle = function (param) {
    return React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["text-primary overflow-hidden", size ? "text-lg" : "text-md leading-tight"]))
    }, React.createElement(DynamicTruncate$Showside.make, {
      lines: 2,
      dataTestId: "qv-pin-card-title",
      children: Product$Showside.getDisplayName(store, variant, pin.product)
    }));
  };
  var renderProductPrice = function (param) {
    return React.createElement("div", {
      className: CSS$Showside.prefix("truncate mt-1 text-secondary")
    }, size ? React.createElement(ProductPrice$Showside.make, {
      at: /* PLP */1,
      product: pin.product,
      variant: variant,
      size: /* Xl */0,
      showMaxPrice: true
    }) : React.createElement(ProductPrice$Showside.make, {
      at: /* PLP */1,
      product: pin.product,
      variant: variant,
      size: /* Sm */2,
      showMaxPrice: false
    }));
  };
  var renderProductReviews = function (param) {
    var match = pin.product.reviewSummary;
    if (size && match !== undefined) {
      return React.createElement(ProductReviews$Showside.Summary.make, {
        at: /* PLP */1,
        summary: match
      });
    } else {
      return null;
    }
  };
  var highlightedCn = highlighted !== undefined && highlighted ? "scale-115 animate-beacon-outline shadow-outline" : "scale-100";
  var dot = React.createElement(DataAttribute$Showside.make, {
    dataTestId: "qv-pin",
    dataId: pin.id,
    children: size ? React.createElement("div", {
      className: Cn.make([CSS$Showside.prefix("animate-grow-in scale-0 transform absolute inset-0 no-touch-highlight"), "swiper-no-swiping"])
    }, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["relative", "rounded-full bg-white w-6 h-6", "-ml-3 -mt-3 left-1/2 top-1/2", "drop-shadow-lg filter", "no-touch-highlight", "transform", "transition-all duration-150 ease-fastoutslow", highlightedCn])),
      style: dotStyle$1
    })) : React.createElement("div", {
      className: Cn.make([CSS$Showside.prefix("rounded-full bg-white w-4 h-4 -ml-2 -mt-2 shadow-outline ease-fastoutslow"), "swiper-no-swiping"]),
      style: dotStyle$1
    })
  });
  var pinContent = size ? React.createElement(ProductListItem$Showside.make, {
    product: pin.product,
    variant: variant,
    shape: shape,
    imageFitStrategy: imageFitToContainer ? /* Contain */2 : /* Cover */1,
    flushed: false,
    padding: true,
    hideOutOfStock: hideOutOfStock,
    onClick: function (param, param$1) {},
    enableDataTestId: false,
    displayVariantBy: displayVariantBy
  }) : React.createElement(React.Fragment, undefined, renderImage(undefined), React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["flex-grow min-w-0 flex flex-col", size ? "space-y-2 ml-3" : "m-2"]))
  }, renderProductReviews(undefined), renderProductTitle(undefined), renderProductPrice(undefined)));
  var tmp$2;
  if (enableTip$1) {
    var tmp$3 = {
      className: CSS$Showside.prefix(Cn.make(["flex justify-start absolute", size ? "items-stretch" : "items-center h-full", "flex-grow w-full"])),
      onClick: onClick$1,
      children: pinContent,
      hasText: true,
      dataId: pin.id,
      dataTestId: "qv-pin-card"
    };
    var tmp$4 = canUseBounds ? Caml_option.some(ReactDOMUtils$Showside.Ref.domRef(tipRef)) : undefined;
    if (tmp$4 !== undefined) {
      tmp$3.fwdRef = Caml_option.valFromOption(tmp$4);
    }
    tmp$2 = React.createElement("div", {
      className: Cn.make([CSS$Showside.prefix("pin-tooltip absolute"), flipped ? CSS$Showside.prefix("pin-tooltip--flipped") : CSS$Showside.prefix("pin-tooltip"), "swiper-no-swiping"])
    }, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["absolute bg-main text-primary rounded-custom shadow-xl", flipped ? "-mt-2" : "mt-8", size === /* Lg */1 ? "" : "px-2", size === /* Lg */1 ? "flex items-center" : ""])),
      style: popupStyle
    }, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["absolute", size ? "-inset-8" : "-inset-4"]))
    }), React.createElement(QuickViewButton$Showside.make, tmp$3)), flipped ? React.createElement("div", {
      className: CSS$Showside.prefix("absolute")
    }, React.createElement(IconTriangleDown$Showside.make, {
      className: CSS$Showside.prefix("w-6 h-4 -ml-3 -mt-11 text-main")
    })) : React.createElement("div", {
      className: CSS$Showside.prefix("absolute")
    }, React.createElement(IconTriangleUp$Showside.make, {
      className: CSS$Showside.prefix("top-0 w-6 h-4 -ml-3 mt-5 text-main")
    })));
  } else {
    tmp$2 = null;
  }
  return React.createElement(Spread$Showside.make, {
    props: {
      "data-pin-id": pin.id,
      "data-product-id": pin.product.id
    },
    children: React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["pin absolute cursor-pointer w-14 h-14 no-touch-highlight", "pointer-events-auto hover:z-10"])),
      style: containerStyle,
      onClick: onClick$1
    }, dot, tmp$2)
  });
}
ProductPin.displayName = "ProductPin";
var make = ProductPin;
export { make };
/* react Not a pure module */